export default __webpack_public_path__ + "static/media/375.bbc11ece.png";